import {
  IconArrowBigRightLines,
  IconBuildingBank,
  IconCode,
  IconCompass,
  IconRocket,
  IconSettings,
  IconSparkles,
  IconUsersGroup,
} from "@tabler/icons-react";
import { SidebarMenu } from "@altimateai/lego";
import { useAppState } from "@/modules/app/useAppContext";
import { isMegaTenant, showWorkflow } from "@/helpers/tenant";
import { isAdmin, isOwner } from "@/services/auth";
import { SidebarCollapsibleItem } from "./SidebarCollapsibleItem";
import { SidebarLink } from "./SidebarLink";
import { SidebarSubLink } from "./SidebarSubLink";

export const FreeUserSidebar = () => {
  const { rbacEnabled, dbtIntegrationEnabled, ssoGroupSyncEnabled } = useAppState();
  const showUserGroupsLink = rbacEnabled;
  const showUsersPage = rbacEnabled ? isAdmin() || isOwner() : true;

  return (
    <SidebarMenu>
      <SidebarLink to="/quickstart" label="Quickstart" icon={<IconArrowBigRightLines />} />
      {dbtIntegrationEnabled && (
        <SidebarLink
          to="/discover"
          query="status=active"
          label="Discover"
          icon={<IconCompass />}
        />
      )}
      <SidebarLink to="/studio" label="Studio" icon={<IconSparkles />} isBeta />
      <SidebarCollapsibleItem
        label="Datamates"
        to="/datamates"
        icon={<IconRocket />}
        activePaths={["/datamates", "/knowledge-hub", "/workflow"]}
      >
        <SidebarSubLink to="/knowledge-hub" label="Knowledge hub" />
        <SidebarSubLink to="/datamates/memories" label="Memory hub" isBeta />
        {showWorkflow() && <SidebarSubLink to="/workflow" label="Workflow" isBeta />}
      </SidebarCollapsibleItem>
      <SidebarCollapsibleItem
        label="Collab"
        to="/collaboration/dbt-docs"
        icon={<IconUsersGroup />}
        activePaths={["/collaboration"]}
      >
        <SidebarSubLink to="/collaboration/export-lineage" label="Export Lineage" />
      </SidebarCollapsibleItem>
      <SidebarLink to="/dbt_models" label="Code" icon={<IconCode />} />
      <SidebarLink to="/governance/dbtconfig" label="Governance" icon={<IconBuildingBank />} />
      <SidebarCollapsibleItem
        label="Settings"
        icon={<IconSettings />}
        activePaths={["/settings", "/usergroups", "/teammates"]}
      >
        <SidebarSubLink to="/settings/api-key" label="API Key" />
        {showUsersPage && <SidebarSubLink to="/settings/users" label="Users" />}
        {showUserGroupsLink && <SidebarSubLink to="/usergroups" label="Teams" />}
        <SidebarSubLink to="/settings/datastores" label="Connections" />
        <SidebarSubLink to="/settings/integrations" label="Integrations" />
        <SidebarSubLink to="/teammates" label="Enable Coaching" />
        <SidebarSubLink to="/settings/tags" label="Tags" />
        <SidebarSubLink to="/settings/credits" label="Credits" />
        {ssoGroupSyncEnabled && isOwner() && (
          <SidebarSubLink to="/settings/sso-group-sync" label="SSO Group Sync" />
        )}
        {ssoGroupSyncEnabled && isOwner() && (
          <SidebarSubLink to="/settings/audit" label="Audit Log" />
        )}
        {isMegaTenant() && <SidebarSubLink to="/referrals" label="Referral Codes" />}
      </SidebarCollapsibleItem>
    </SidebarMenu>
  );
};
